export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-arrow-up-line',
      title: 'Build a Revenue Platform',
      description: 'Own your revenue streams. Create recurring income through services, memberships, and products you control.',
    },
    {
      icon: 'ri-key-line',
      title: 'Build Your Own Asset',
      description: 'Create long-term client relationships you own, not tied to any single employer or clinic.',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Work on Your Terms',
      description: 'Flexible scheduling with a remote-first model. Fit teleconsults around your existing commitments.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Lower-Risk Independence',
      description: 'Test entrepreneurship without opening a full clinic. No overhead, no staff, no startup costs.',
    },
  ];

  return (
    <section id="benefits" className="py-24 lg:py-32 bg-[#F4F7FB]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-xs font-semibold tracking-widest uppercase text-[#4DB8D4] mb-4 block">
            Why Vetuvia
          </span>
          <h2 className="text-4xl lg:text-5xl font-serif text-gray-900">
            Own Your Practice. Own Your Revenue.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center group">
              <div className="mb-6 flex justify-center">
                <div className="w-18 h-18 bg-white rounded-full shadow-md flex items-center justify-center group-hover:shadow-xl transition-shadow">
                  <i className={`${benefit.icon} text-4xl text-[#4DB8D4]`}></i>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}